import CloseIcon from '@mui/icons-material/Close';
import {Grid, IconButton} from '@mui/material';

import EmpionDialog from '../../../../../../components/EmpionDialog/EmpionDialog';
import {RejectionReasonModal} from '../../../../../../components/RejectionReasonModal/RejectionReasonModal';
import {CompanyRejectionReasonBody} from '../../../../../../lib/api/RequestBodies/shared-recruiting/SharedRecruitingRequestBodies';
import {ApiResponseError} from '../../../../../../lib/api/v1/types';

interface Props {
  isModalOpen: boolean;
  setModalOpen: (isOpen: boolean) => void;
  onReject: (body: CompanyRejectionReasonBody) => void;
  isLoading: boolean;
  error?: ApiResponseError;
}
export const RejectMatch = ({isModalOpen, setModalOpen, onReject, isLoading, error}: Props) => {
  return (
    <EmpionDialog
      open={isModalOpen}
      onClose={() => {
        setModalOpen(false);
      }}
    >
      <Grid container justifyContent={'flex-end'}>
        <IconButton
          onClick={() => {
            setModalOpen(false);
          }}
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      <RejectionReasonModal rejectionType='company' onReject={onReject} isUpdatingMatch={isLoading} error={error} />
    </EmpionDialog>
  );
};
